export enum FactureStatus {
  EN_COURS = "en_cours",
  ENCAISSE = "encaisse",
  IMPAYE = "impaye"
}

export interface FactureItem {
  id?: number;
  bon_livraison_item_id?: number;
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
}

export interface FactureItemCreate {
  bon_livraison_item_id?: number;
  designation?: string;
  quantite?: number;
  prix_unitaire: number;
  total: number;
}

export interface BonLivraisonSimple {
  id: number;
  reference: string;
  date: string;
  bon_commande_number?: string;
}

export interface Facture {
  id: number;
  reference: string;
  date: string;
  type?: 'normale' | 'acompte';
  client_id: number;
  client_name?: string;
  client_ice?: string;
  client_address?: string;
  devis_id?: number;
  devis_reference?: string;
  acompte_percentage?: number;
  bc_numero?: string;
  remarque?: string;
  total_ht: number;
  tva_rate: number;
  tva_amount: number;
  remise: number;
  remise_amount: number;
  total_net: number;
  total_acompte: number;
  net_a_payer: number;
  status: FactureStatus;
  user_id: number;
  user_name?: string;
  created_at: string;
  updated_at?: string;
  deleted_at?: string;
  items: FactureItem[];
  bons_livraison: BonLivraisonSimple[];
  acompte_deductions: AcompteDeduction[];
}

export interface AcompteDeduction {
  id: number;
  acompte_facture_id: number;
  reference: string;
  montant: number;
}

export interface FactureCreate {
  date: string;
  client_id: number;
  type?: string;
  devis_id?: number;
  acompte_percentage?: number;
  bc_numero?: string;
  remarque?: string;
  tva_rate: number;
  remise: number;
  items: FactureItemCreate[];
  acompte_deduction_ids?: number[];
}

export interface FactureUpdate {
  date?: string;
  client_id?: number;
  type?: string;
  devis_id?: number;
  acompte_percentage?: number;
  bc_numero?: string;
  remarque?: string;
  tva_rate?: number;
  remise?: number;
  items?: FactureItemCreate[];
  acompte_deduction_ids?: number[];
}

export interface AvailableAcompte {
  id: number;
  reference: string;
  devis_reference: string | null;
  acompte_percentage: number;
  total_net: number;
  status: string;
}

export interface DevisAcompteInfo {
  devis_id: number;
  devis_reference: string;
  total_percentage_used: number;
  remaining_percentage: number;
  acompte_factures: {
    id: number;
    reference: string;
    acompte_percentage: number;
    total_net: number;
    status: string;
  }[];
}
